import { interfaces } from "inversify";

import { UserProfileService } from "./api/userProfile.service";
import { UserProfileServiceInterface } from "./api/userProfile.serviceInterface";

export class ApiServiceBinder {
  public static with(container: interfaces.Container) {
    container
      .bind(UserProfileServiceInterface)
      .to(UserProfileService)
      .inSingletonScope();
  }
}
